import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '@app/modules/menu/menu.component';
import { MenuRoutingModule } from '@app/modules/menu/menu-routing.module';
import { SharedComponentsModule } from '@app/shared/components/shared-components.module';
import { ProductsDialogEntryComponent } from '@app/modules/menu/components/products-dialog-entry/products-dialog-entry.component';
import { DealsDialogEntryComponent } from '@app/modules/menu/components/deals-dialog-entry/deals-dialog-entry.component';
import { MenuCardComponent } from '@app/modules/menu/components/menu-card/menu-card.component';
import { FilterMenuItemsPipe } from '@app/modules/menu/pipes/menu-sections-filter';
import { WantedTimePickerComponent } from '@app/shared/components/wanted-time/wanted-time-picker/wanted-time-picker.component';
import { DealUpsellModalComponent } from '@app/modules/menu/components/deal-upsell-modal/deal-upsell-modal.component';
@NgModule({
  declarations: [
    MenuComponent,
    ProductsDialogEntryComponent,
    DealsDialogEntryComponent,
    MenuCardComponent
  ],
  imports: [
    CommonModule,
    MenuRoutingModule,
    SharedComponentsModule,
    WantedTimePickerComponent,
    FilterMenuItemsPipe,
    DealUpsellModalComponent
  ]
})
export class MenuModule {}
